import {ApplicationConfig, importProvidersFrom, LOCALE_ID, provideZoneChangeDetection} from '@angular/core';
import {provideRouter, withRouterConfig} from '@angular/router';
import {provideHttpClient} from '@angular/common/http';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {CldrIntlService, IntlService} from '@progress/kendo-angular-intl';
import '@progress/kendo-angular-intl/locales/cs/all';
import {routes} from './app.routes';
import {FirstDayIntlService} from 'cgm-ui';
import {NgHcaptchaModule} from 'ng-hcaptcha';
import {environment} from '../environments/environment.development';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({eventCoalescing: true}),
    provideRouter(
      routes,
      withRouterConfig({paramsInheritanceStrategy: 'always'})
    ),
    provideHttpClient(),
    importProvidersFrom(
      BrowserModule,
      BrowserAnimationsModule,
      NgHcaptchaModule.forRoot({
        siteKey: environment.siteKey,
        languageCode: "cs",
      }),
    ),
    { provide: IntlService, useClass: CldrIntlService },
    { provide: IntlService, useClass: FirstDayIntlService },
    { provide: LOCALE_ID, useValue: 'cs-CZ' },
  ]
};
